
import InteractContext from "@combostrap/interact/components/contexts/InteractContext";

const contextComponents = {
  interactcontext: InteractContext
};
export function getContextComponents() {
  return contextComponents;
}

export { InteractContext };

// to not return null
const dontUse = () => "Don't use the default export";
export default dontUse 
